<template>
  <div class="layout-home-use">
    <div :class="[isDesktop ? 'desktop-layout-home-use': 'mobile-layout-home-use']">
      <div class="home-use-top">
      <el-tooltip :content="$t('editor_home_function_title1_tooltip')" :popper-style="{ maxWidth: '220px' }"
        placement="top" :show-after="0" :hide-after="0">
        <div class="use-item use-ocr">
          <i class="iconfont icon-icon_ocr" />
          <div class="use-item-title-lock">
            {{ $t("editor_home_function_title1") }}
          </div>
        </div>
      </el-tooltip>
      <el-tooltip :content="$t('editor_home_function_title2_tooltip')" :popper-style="{ maxWidth: '220px' }"
        placement="top" :show-after="0" :hide-after="0">
        <div class="use-item use-delete">
          <i class="iconfont icon-icon_History" />
          <div class="use-item-title-delete">
            {{ $t("editor_home_function_title2") }}
          </div>
        </div>
      </el-tooltip>
      <el-tooltip :content="$t('editor_home_function_title3_tooltip')" :popper-style="{ maxWidth: '220px' }"
        placement="top" :show-after="0" :hide-after="0">
        <div class="use-item use-login">
          <i class="iconfont icon-icon_open_n1" />
          <div class="use-item-title-login">
            {{ $t("editor_home_function_title3") }}
          </div>
        </div>
      </el-tooltip>
      <el-tooltip :content="$t('editor_home_function_title4_tooltip')" :popper-style="{ maxWidth: '220px' }"
        placement="top" :show-after="0" :hide-after="0">
        <div class="use-item use-local">
          <i class="iconfont icon-icon_protect" />
          <div class="use-item-title-local">
            {{ $t("editor_home_function_title4") }}
          </div>
        </div>
      </el-tooltip>

      </div>
      <div class="home-use-tips">
        <i class="iconfont icon-icon_protect_1" />
        <span class="home-use-tips-title">
          {{ $t("editor_home_use_tips1") }}
        </span>
        <i class="iconfont icon-icon_y" />
        <span class="home-use-tips-title">
          {{ $t("editor_home_use_tips2") }}
        </span>
        <i class="iconfont icon-icon_team" />
        <span class="home-use-tips-title">
          {{ $t("editor_home_use_tips3") }}
        </span>
      </div>
      <!-- <div class="home-use-tools">
            <div class="home-use-tools-title">
              {{ $t("editor_home_use_tools_title") }}
            </div>
            <div class="home-use-tools-subTitle">
              {{ $t("editor_home_use_tools_subTitle") }}
            </div>
            <div class="home-use-tools-items">
              <div class="home-use-tools-item converter" @click="handleToolsClick(1)">
                <i class="iconfont icon-icon_pdf6" />
                <div class="home-use-tools-item-title">
                  {{ $t("editor_home_use_tools_item1_title") }}
                </div>
                <div class="home-use-tools-item-subTitle">
                  {{ $t("editor_home_use_tools_item1_subTitle") }}
                </div>
              </div>
              <div class="home-use-tools-item compressor"  @click="handleToolsClick(2)">
                <i class="iconfont icon-icon_pdf_compress" />
                <div class="home-use-tools-item-title">
                  {{ $t("editor_home_use_tools_item2_title") }}
                </div>
                <div class="home-use-tools-item-subTitle">
                  {{ $t("editor_home_use_tools_item2_subTitle") }}
                </div>
              </div>
              <div class="home-use-tools-item merger"  @click="handleToolsClick(3)">
                <i class="iconfont icon-icon_pdf_merge" />
                <div class="home-use-tools-item-title">
                  {{ $t("editor_home_use_tools_item3_title") }}
                </div>
                <div class="home-use-tools-item-subTitle">
                  {{ $t("editor_home_use_tools_item3_subTitle") }}
                </div>
              </div>
              <div class="home-use-tools-item decryptor"  @click="handleToolsClick(4)">
                <i class="iconfont icon-icon_pdf_decrypt" />
                <div class="home-use-tools-item-title">
                  {{ $t("editor_home_use_tools_item4_title") }}
                </div>
                <div class="home-use-tools-item-subTitle">
                  {{ $t("editor_home_use_tools_item4_subTitle") }}
                </div>
              </div>
            </div>
          </div> -->
      <div class="home-use-content">
        <div class="home-use-content-left">
          <CommonImage src="/assets/images/home/homeEditBg.webp" class="home-use-content-left-img"
          />
        </div>
        <div class="home-use-content-right">
          <div class="title">
            {{ $t("editor_home_use_content_title") }}
          </div>
          <div class="subTitle">
            {{ $t("editor_home_use_content_subTitle") }}
          </div>
          <Step :stepList="stepList" @titleClick="handleTitleClick" :titleSelected="true" />
          <div class="btn" @click="handleOperateRecordClick">
            {{ $t("editor_home_use_content_btn") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import useBasicStore from '~/store/modules/basic'
import useSystemLaunageStore from '~/store/modules/systemLaunage'
import Step from '~/components/Step/index.vue'
import CommonImage from '~/components/CommonImage/CommonImage.vue'
import eventBus from 'vue3-eventbus'
import { EventHomeMessage } from '~/config/event'
const viewport = useViewport()
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))
const basicStore = useBasicStore()
const { isChina } = storeToRefs(basicStore)
const systemLanguageStore = useSystemLaunageStore()
const { systemLanguage } = storeToRefs(systemLanguageStore)
const { t, locale } = useI18n()

const stepList = ref([
  {title: t("editor_home_use_content_step1_title"), subTitle: t("editor_home_use_content_step1_subTitle")},
  {title: t("editor_home_use_content_step2_title"), subTitle: t("editor_home_use_content_step2_subTitle")},
  {title: t("editor_home_use_content_step3_title"), subTitle: t("editor_home_use_content_step3_subTitle")},
  {title: t("editor_home_use_content_step4_title"), subTitle: t("editor_home_use_content_step4_subTitle")}
])

watch(locale, (newVal) => {
  console.log(newVal)
  stepList.value = [
    {title: t("editor_home_use_content_step1_title"), subTitle: t("editor_home_use_content_step1_subTitle")},
    {title: t("editor_home_use_content_step2_title"), subTitle: t("editor_home_use_content_step2_subTitle")},
    {title: t("editor_home_use_content_step3_title"), subTitle: t("editor_home_use_content_step3_subTitle")},
    {title: t("editor_home_use_content_step4_title"), subTitle: t("editor_home_use_content_step4_subTitle")}
  ]
})

const handleOperateRecordClick = () => {
   eventBus.emit(EventHomeMessage.operateRecordClick)
}

// 1 转换器;2 压缩器;3 合并器;4 解密器
const handleToolsClick = (type: number) => {
  console.log(type, 'type')
  let path;
  switch (type) {
    case 1:
      path = 'home/PDFToWord'
      break
    case 2:
      path = 'home/PDFCompress'
      break
    case 3:
      path = `home/PDFMerge`
      break
    case 4:
      path = 'home/PDFRemovePassword'
      break
    default:
      break
  }
  // 跳转其他链接
  if (path) {
    window.open(`${useRuntimeConfig().public.doclingoUrl}${path}`, '_blank')
  }
}

const handleTitleClick = (item: any) => {
  console.log(item, 'item')
}

onMounted(() => {

})

</script>

<style scoped lang="scss">
@use "./index.scss" as *;
@use "./mobile.scss" as *;
</style>
